<template>
  <div>
    <v-btn icon elevation="13" color="secondary" class="ma-1 accent lighten-5" dark @click="openCalendar(userId)">
      <v-icon>mdi-calendar</v-icon>
    </v-btn>

    <v-dialog v-model="showCalendar" class="limited-height" width="900" transition="dialog-bottom-transition">
      <v-card>
        <calendar v-if="showCalendar" :userId="selectedUserId"></calendar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Calendar from "../Calendar";

export default {
  name: "CalendarColumn",
  data() {
    return {
      showCalendar: false,
      selectedUserId: null
    }
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  components: {
    Calendar
  },
  methods: {
    openCalendar(userId) {
      this.selectedUserId = userId;
      this.showCalendar = true;
    },
    closeCalendar() {
      this.showCalendar = false;
    },
  }
};
</script>
